import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Shipment } from 'src/app/domain/Shipment';
import { StepperService } from 'src/app/pages/Shared/stepper/stepper.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-exchange-pallets',
  templateUrl: './exchange-pallets.component.html',
  styleUrls: ['./exchange-pallets.component.scss']
})
export class ExchangePalletsComponent implements OnInit {

  @Input() shipment!: Shipment;
  @Input() removeBtns: boolean = false;

  isDisabled = true;

  exchangePalletsFormGroup = new FormGroup({
    includeExchangePallets: new FormControl(false),
    exchangePallets: new FormGroup({
      fullExchangePallets: new FormControl({ value: 0, disabled: this.isDisabled }),
      halfExchangePallets: new FormControl({ value: 0, disabled: this.isDisabled }),
      quarterExchangePallets: new FormControl({ value: 0, disabled: this.isDisabled }),
    })
  });

  constructor(public stepperService: StepperService, private auth: AuthService) {
    this.shipment = this.stepperService.newShipment;
    this.ExchangePalletPreFligth();
    this.exchangePalletsFormGroup.get('includeExchangePallets')?.valueChanges.subscribe((checked: boolean) => {
      if (checked) {
        // this.shipment.exchangePallets = true;
        this.exchangePalletsFormGroup.get('exchangePallets').enable();
        // resets the coutn for the exchange fields.
        this.exchangePalletsFormGroup.get('exchangePallets')?.get('fullExchangePallets')?.setValue(0);
        this.exchangePalletsFormGroup.get('exchangePallets')?.get('halfExchangePallets')?.setValue(0);
        this.exchangePalletsFormGroup.get('exchangePallets')?.get('quarterExchangePallets')?.setValue(0);
        // counts the types and adds the total to exchange tally.
        this.shipment.collis.forEach(colli => {
          switch (colli.type) {
            case "1/1":
              this.exchangePalletsFormGroup.get('exchangePallets')?.get('fullExchangePallets')?.setValue(this.exchangePalletsFormGroup.get('exchangePallets')?.get('fullExchangePallets')?.value + (colli.quantity ?? 0));
              break;
            case "1/2":
              this.exchangePalletsFormGroup.get('exchangePallets')?.get('halfExchangePallets')?.setValue(this.exchangePalletsFormGroup.get('exchangePallets')?.get('halfExchangePallets')?.value + (colli.quantity ?? 0));
              break;
            case "1/4":
              this.exchangePalletsFormGroup.get('exchangePallets')?.get('quarterExchangePallets')?.setValue(this.exchangePalletsFormGroup.get('exchangePallets')?.get('quarterExchangePallets')?.value + (colli.quantity ?? 0));
              break;
          }
        });
      } else {
        // this.shipment.exchangePallets = false;
        this.exchangePalletsFormGroup.get('exchangePallets').disable();
        this.shipment.fullExchangePallets.quantity = 0;
        this.shipment.halfExchangePallets.quantity = 0;
        this.shipment.quarterExchangePallets.quantity = 0;

        this.exchangePalletsFormGroup.get('exchangePallets')?.get('fullExchangePallets')?.setErrors(null);
        this.exchangePalletsFormGroup.get('exchangePallets')?.get('halfExchangePallets')?.setErrors(null);
        this.exchangePalletsFormGroup.get('exchangePallets')?.get('quarterExchangePallets')?.setErrors(null);

      }
    });

    this.exchangePalletsFormGroup.get('exchangePallets')?.valueChanges.subscribe((value: any) => {
      var foundError = false;
      if (value.fullExchangePallets > 1000) {
        this.exchangePalletsFormGroup.get('exchangePallets')?.get('fullExchangePallets')?.setErrors({ max: true });
        foundError = true;
      }
      if (value.halfExchangePallets > 1000) {
        this.exchangePalletsFormGroup.get('exchangePallets')?.get('halfExchangePallets')?.setErrors({ max: true });
        foundError = true;
      }
      if (value.quarterExchangePallets > 1000) {
        this.exchangePalletsFormGroup.get('exchangePallets')?.get('quarterExchangePallets')?.setErrors({ max: true });
        foundError = true;
      }

      if (foundError) {
        return;
      }

      this.shipment.fullExchangePallets.quantity = value.fullExchangePallets != null ? value.fullExchangePallets : 0;
      this.shipment.halfExchangePallets.quantity = value.halfExchangePallets != null ? value.halfExchangePallets : 0;
      this.shipment.quarterExchangePallets.quantity = value.quarterExchangePallets != null ? value.quarterExchangePallets : 0;

    });

  }

  ngOnInit(): void {
    if (!this.shipment.fullExchangePallets) {
      this.shipment.fullExchangePallets = { quantity: 0, deviation: 0 };
    }
    if (!this.shipment.halfExchangePallets) {
      this.shipment.halfExchangePallets = { quantity: 0, deviation: 0 };
    }
    if (!this.shipment.quarterExchangePallets) {
      this.shipment.quarterExchangePallets = { quantity: 0, deviation: 0 };
    }
    if (this.auth.hasSetting("palletexchange.auto"))
      this.exchangePalletsFormGroup.controls.includeExchangePallets.setValue(true);

    if (this.shipment.fullExchangePallets?.quantity || this.shipment.halfExchangePallets?.quantity || this.shipment.quarterExchangePallets?.quantity) {
      this.exchangePalletsFormGroup.get('includeExchangePallets')?.setValue(true, { emitEvent: false });
      this.exchangePalletsFormGroup.get('exchangePallets').enable({ emitEvent: false });
      this.exchangePalletsFormGroup.get('exchangePallets')?.get('fullExchangePallets')?.setValue(this.shipment.fullExchangePallets.quantity, { emitEvent: false });
      this.exchangePalletsFormGroup.get('exchangePallets')?.get('halfExchangePallets')?.setValue(this.shipment.halfExchangePallets.quantity, { emitEvent: false });
      this.exchangePalletsFormGroup.get('exchangePallets')?.get('quarterExchangePallets')?.setValue(this.shipment.quarterExchangePallets.quantity, { emitEvent: false });
    }

  }

  ExchangePalletPreFligth() {
    if ((this.shipment.collis == null || this.shipment.collis == undefined))
      return;
    this.shipment.collis.forEach(colli => {
      switch (colli.type) {
        case "1/1":
          this.exchangePalletsFormGroup.get('exchangePallets')?.get('fullExchangePallets')?.setValue(this.exchangePalletsFormGroup.get('exchangePallets')?.get('fullExchangePallets')?.value + (colli.quantity ?? 0));
          break;
        case "1/2":
          this.exchangePalletsFormGroup.get('exchangePallets')?.get('halfExchangePallets')?.setValue(this.exchangePalletsFormGroup.get('exchangePallets')?.get('halfExchangePallets')?.value + (colli.quantity ?? 0));
          break;
        case "1/4":
          this.exchangePalletsFormGroup.get('exchangePallets')?.get('quarterExchangePallets')?.setValue(this.exchangePalletsFormGroup.get('exchangePallets')?.get('quarterExchangePallets')?.value + (colli.quantity ?? 0));
          break;
      }
    });
  }

}
